import IconButton from "components/elements/IconButton";
import Table from "components/elements/Table";
import { LS_CLONE_REGROUP_KEY,LS_NAME_REGROUP_NAME} from "core/Constants";
import dataProvider from "core/DataProvider";
import { useEffect, useState } from "react";
import { ReactComponent as EditIcon } from "../../../images/edit.svg";
import IconInput from "components/elements/IconInput";
import utility from "core/Utils";
//import { useState } from "react";
import toast from "react-hot-toast";
//import { useEffect } from "react";
//import Exporter from "components/elements/Exporter";
import { useNavigate } from "react-router-dom";

const headerMap = {
  group_name: "Group Name",
  is_expired: "Expired",
  period_from:"Period From",
  period_to:"Period To",
  tolerance_day:"Tolerance Day",
 action: "Actions"
};




const ClientListing = props => {
  const navigate = useNavigate();
const [groupsre, setGroups] = useState([]);
  //const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
const loadGroupsRenewList = async () => {
    try {
      let groupsre = await dataProvider.network.get("renewal/groups");
      groupsre = groupsre.map(x => ({
        ...x,

        is_expired: x.is_expired ? <button className="bg-sign-red">Yes</button> : <button className="bg-sign-green">No</button>,
        period_from: utility.formatDate(x.period_from),
        period_to: utility.formatDate(x.period_to),
        action: x.is_expired ? <div className="action flex flex-v-center"  onClick={() => editClient(x.group_id,x.group_name)} > <div className="action-button flex flex-center"><EditIcon /></div></div>:null,
      }));
      setGroups(groupsre);
    } catch (error) {
      toast.error("Failed to load groups");
    } finally {
      setLoading(false);
    }
  };
//const data =  loadGroupsRenewList;

  const [search, setSearch] = useState("");
//  const [loading] = useState(true);
//setLoading(false);
  //const token = useOutletContext();



  // Edit click handler
   const editClient = (client,grpname) => {
  //   // set details in localstorage
     localStorage.setItem(LS_CLONE_REGROUP_KEY, JSON.stringify(client));
     localStorage.setItem(LS_NAME_REGROUP_NAME, JSON.stringify(grpname));
  //   // redirect to new client page
     navigate("/clients/grpRenewList");
   };


 useEffect(() => {
    loadGroupsRenewList();
  }, []);
  return (
    <section id="client-list-container">
      <div className="flex">
        <div className="right flex flex-v-center">

        </div>
      </div>
      <div className="box mtop pad-1">
        <div className="flex flex-v-center">
          <h3 className="pad-lr">Clients Renewlist</h3>
          <div className="right flex flex-v-center" style={{width:"35%"}}>
            <div className="el">
              {loading && (
                <div className="loader">
                  <div className="lds-hourglass"></div>
                </div>
              )}
            </div>
          <div className="el pad-lr">
            <IconInput
                value={search}
                onChange={e => setSearch(e.target.value)}
                placeholder="Search (min 3 character)"
                icon="search"
                style={{ minWidth: "250px" }}
              /></div>
            <div className="pad-lr" style={{ marginLeft: "0" }}>

            </div>
          </div>
        </div>
        <div className="mtop table-data">

   <Table
            headers={headerMap}
            data={groupsre}
            search={search}
          />
        </div>
      </div>
    </section>
  );
};

export default ClientListing;
